// extracted by mini-css-extract-plugin
export default {"phone-wrapper":"phone-wrapper--1x51j","animation":"animation--2X5hq","spin":"spin--1TBvF"};